import { type Registry as Services, service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';
import { tracked } from '@glimmer/tracking';
import { Type } from '@warp-drive/core-types/symbols';
import type { Dayjs } from 'dayjs';
import type { TotalRevenueTrendItem } from 'lumen/models';

export default class TotalRevenueTrendReference extends Model {
  [Type] = 'total-revenue/trend-reference' as const;

  @belongsTo('total-revenue/trend-item', {
    async: false,
    inverse: 'referenceValues',
  })
  declare totalRevenueItem: TotalRevenueTrendItem;

  @attr('number') declare nonRoomPremium: number;
  @attr('hoteldate') declare referenceFromDate: Dayjs;
  @attr declare referenceType: string;
  @attr('number') declare totalNonRoomRevenue: number;
  @attr('number') declare totalRevenue: number;
  @attr('number') declare totalRoomRevenue: number;

  @service('total-revenue')
  declare totalRevenueService: Services['total-revenue'];

  @tracked capacity?: number;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get totalNonRoomRevenueOrPAR() {
    return this.totalRevenueService.valueOrPAR(
      this.totalNonRoomRevenue,
      this.capacity,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get totalRevenueOrPAR() {
    return this.totalRevenueService.valueOrPAR(
      this.totalRevenue,
      this.capacity,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get totalRoomRevenueOrPAR() {
    return this.totalRevenueService.valueOrPAR(
      this.totalRoomRevenue,
      this.capacity,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get translatedReferenceType() {
    return this.totalRevenueService.translateReferenceType(this.referenceType);
  }
}
